import { Component, OnInit } from '@angular/core';
import { DataService } from "../../bpg-common/services/data.services";
import { Budget, Hoshin, BudgetHoshin } from "../../bpg-common/services/data.services";
import { HoshinBudgetService } from "../hoshin-budget.service";
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router } from '@angular/router';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';

@Component({
  selector: 'app-view-hoshin',
  templateUrl: './view-hoshin.component.html',
  styleUrls: ['./view-hoshin.component.css']
})
export class ViewHoshinComponent implements OnInit {
  budgetData: any = null;
  budget: Budget;
  hoshins: Hoshin[];
  approveData: any[] = [];
  approve: any;
  completeData: any;
  alertTrue: any = false;
  msg1: string;
  msg2: string;
  method: string;
  param: string;
  budgetHoshin: BudgetHoshin = new BudgetHoshin();
  approveAlertSuccess: boolean;
  rejectAlertSuccess: boolean;
  saveAlertSuccess: boolean;
  errorMsg: string;
  alertFailure: boolean = false;
  alertError: boolean = false;
  loginData = JSON.parse(localStorage.getItem('loginData'));
  adminId: any;
  approveComment: boolean;
  approveAmount: boolean;
  isCollapsed = [];
  buttonType: any;
  loginDetails: any;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  printClicked: boolean = false;
  isbpgAdmin: boolean = false;
  isbpgLeadAdmin = false;
  isNaacAdmin: boolean = false;
  constructor(private data: DataService,
    private hoshinBudgetService: HoshinBudgetService,
    private location: Location,
    private spinner: Ng4LoadingSpinnerService,
    private router: Router,
    
    private environment: EnvironmentConfiguration
  ) { }

  ngOnInit() {
    this.printClicked = false;
    if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
              if (localStorage.getItem('loginData')== null || localStorage.getItem('loginData')== undefined) {

        this.router.navigate(['/log-out']);
      }
    }

    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 500);

    this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
    if(localStorage.getItem('isbpgAdmin') == 'true')
    {
      this.isbpgAdmin = true
    }
    if(localStorage.getItem('isbpgLeadAdmin') === 'true')
    {
      this.isbpgLeadAdmin = true
    }
    if(localStorage.getItem('isNaacAdmin') == 'true')
    {
      this.isNaacAdmin = true
    }
    this.adminId = localStorage.getItem('adminId');
    if (this.adminId !== '1' && this.adminId !== '2' && this.adminId !== '3' && this.adminId !== '4' && !this.isbpgAdmin && !this.isbpgLeadAdmin && !this.isNaacAdmin) {
      this.router.navigate(['/site-home']);
      
    }
    // if (this.loginDetails == null) {
    //   this.router.navigate(['/login']);
    // }
    //this.data.budgetData.subscribe(data => this.budgetData = data);
    this.budgetData = JSON.parse(sessionStorage.getItem('saveBudget'))
    if (this.budgetData.approvedBudgetAmount == null) {
      this.budgetData.approvedBudgetAmount = 0;
    }
    this.budget = this.budgetData;
    this.hoshinBudgetService.getHoshins(this.budgetData.budgetId).subscribe(data => {
      this.hoshins = data;
      setTimeout(() => {
        const approveLength = document.querySelectorAll('input[name=approveCheck]:checked').length;
        this.completeData = this.hoshins.length;
        if (approveLength == this.completeData) {
          this.alertTrue = true;
        } else {
          this.alertTrue = false;
        }
      }, 1000)
    }, err => {
      this.spinner.hide();
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  /** month year selection
 * @class ViewHoshinComponent
 * @method findTotalBudgetAmount
 */
  findTotalBudgetAmount() {
    var total = 0;
    for (var i = 0; i < this.hoshins.length; i++) {
      if (this.hoshins[i].superAdminApprovedBudget) {
        var parsedBudget: number;
        parsedBudget = Number(this.hoshins[i].superAdminApprovedBudget);
        total = total + parsedBudget;
        this.budget.approvedBudgetAmount = total;
      }
    }
  }

  /** to check whether approved and pending approval
* @class ViewHoshinComponent
* @method toggleCheckbox
*/
  toggleCheckbox(event, apr) {
    if (event.target.checked) {
      this.approveData.push(apr);
    } else {
      const index: number = this.approveData.indexOf(apr);
      if (index !== -1) {
        this.approveData.splice(index, 1);
      }
    }
    const approveLength = document.querySelectorAll('input[name=approveCheck]:checked').length;
    this.approve = this.approveData.length;
    this.completeData = this.hoshins.length;
    // if (this.approve == this.completeData) {
    if (approveLength == this.completeData) {
      this.alertTrue = true;
    }
    else {
      this.alertTrue = false;
    }
  }

  public goBack() {
    sessionStorage.setItem(this.buttonType, "BACK");
    this.location.back();
  }


  /** to select confirm
      * @class ViewHoshinComponent
      * @method approveBtnClick
      */
  approveBtnClick() {
    this.findTotalBudgetAmount();
    for (var i = 0; i < this.hoshins.length; i++) {
      if (this.hoshins[i].isSuperAdminApproved == null) {
        this.hoshins[i].isSuperAdminApproved = false;
      }
      if (this.hoshins[i].superAdminApprovalComment == null || (this.hoshins[i].superAdminApprovalComment != null && this.hoshins[i].superAdminApprovalComment.trim() == "")) {
        this.approveComment = true;
        this.approveAmount = false;
        document.getElementById('approveBtnClick').removeAttribute('data-target');
        document.getElementById('approveBtnClick').removeAttribute('data-toggle');
        return;
      }
      else if (this.hoshins[i].isSuperAdminApproved) {
        if (this.hoshins[i].superAdminApprovedBudget == null) {
          this.approveAmount = true;
          this.approveComment = false;
          document.getElementById('approveBtnClick').removeAttribute('data-target');
          document.getElementById('approveBtnClick').removeAttribute('data-toggle');
          return;
        }
      }
      this.approveComment = false;
      this.approveAmount = false;
      document.getElementById('approveBtnClick').setAttribute('data-target', '#myModal');
      document.getElementById('approveBtnClick').setAttribute('data-toggle', 'modal');
      this.method = "approveBudget";
      this.param = "approve";
      this.msg1 = " Do you want to approve this Hoshin ?";
    }

  }

  /** to select confirm
    * @class ViewHoshinComponent
    * @method rejectBtnClick
    */
  public rejectBtnClick() {
    for (var i = 0; i < this.hoshins.length; i++) {
      if (this.hoshins[i].isSuperAdminApproved == null) {
        this.hoshins[i].isSuperAdminApproved = false;
      }
      if (this.hoshins[i].superAdminApprovalComment == null || (this.hoshins[i].superAdminApprovalComment != null && this.hoshins[i].superAdminApprovalComment.trim() == "")) {
        this.approveComment = true;
        this.approveAmount = false;
        document.getElementById('rejectBtnClick').removeAttribute('data-target');
        document.getElementById('rejectBtnClick').removeAttribute('data-toggle');
        return;
      }
      else if (this.hoshins[i].isSuperAdminApproved) {
        if (this.hoshins[i].superAdminApprovedBudget == null) {
          this.approveAmount = true;
          this.approveComment = false;
          document.getElementById('rejectBtnClick').removeAttribute('data-target');
          document.getElementById('rejectBtnClick').removeAttribute('data-toggle');
          return;
        }
      }
      this.approveComment = false;
      this.approveAmount = false;
      document.getElementById('rejectBtnClick').setAttribute('data-target', '#myModal');
      document.getElementById('rejectBtnClick').setAttribute('data-toggle', 'modal');
      this.method = "approveBudget";
      this.param = "reject";
      this.msg1 = " Do you want to reject this Hoshin ?";
    }
  }

  /** For approving budget
 * @class ViewHoshinComponent
 * @method approveBudget
 */
  public approveBudget(action) {
    this.timeOutError = false;
    // for (var i = 0; i < this.hoshins.length; i++) {
    //   if(this.hoshins[i].isSuperAdminApproved == null){
    //    this.hoshins[i].isSuperAdminApproved= false;
    //   }
    //   if (this.hoshins[i].superAdminApprovalComment == null || (this.hoshins[i].superAdminApprovalComment != null && this.hoshins[i].superAdminApprovalComment.trim() == "") ) {
    //        this.approveComment = true;
    //        this.approveAmount = false;
    //        return;
    //      }
    //   else if(this.hoshins[i].isSuperAdminApproved){
    //    if(this.hoshins[i].superAdminApprovedBudget == null)
    //     {
    //     this.approveAmount = true;
    //     this.approveComment = false;
    //     return;
    //     }
    //   }
    // }
    if (action == 'approve') {
      this.budget.budgetStatus = 'APPROVED';
      this.budget.budgetAllocatedBy = this.loginData['userId'];
      //Boolean to indicate it is save action
      this.budgetHoshin.hoshinSave = false;
    } else if (action == 'reject') {
      this.budget.budgetStatus = 'REJECTED';
      this.budget.budgetAllocatedBy = this.loginData['userId'];
      this.budget.approvedBudgetAmount = null;
      //Boolean to indicate it is save action
      this.budgetHoshin.hoshinSave = false;
    } else if (action == 'save') {
      this.budget.budgetStatus = 'RESUBMITTED';
      this.budget.budgetAllocatedBy = this.loginData['userId'];
      //Boolean to indicate it is save action
      this.budgetHoshin.hoshinSave = true;
    }
    this.spinner.show();
    this.budgetHoshin.budgetMasterDTO = this.budget;
    this.budgetHoshin.hoshinMasterDTOList = this.hoshins;

    this.hoshinBudgetService.saveBudget(this.budgetHoshin).subscribe(data => {
      this.spinner.hide();
      if (data != null && data.body.message == undefined) {
        window.scrollTo(0, 0);
        if (action == 'approve') {
          this.approveAlertSuccess = true;
        } else if (action == 'reject') {
          this.rejectAlertSuccess = true;
        } else if (action == 'save') {
          this.saveAlertSuccess = true;
          this.budget.budgetStatus = 'SUBMITTED';
        }
        if (this.rejectAlertSuccess == true) {
          this.budget.approvedBudgetAmount = 0;
        }

        window.scrollTo(0, 0);
        if (action != 'save') {
          setTimeout(function () {
            this.router.navigate(['/hoshin-listing']);
          }.bind(this), 6000);
        }
      } else if (data != null && data.body.message != undefined) {
        this.errorMsg = data.body.message.split(":")[0];
        this.alertFailure = true;
        setTimeout(function () {
          this.alertFailure = false;
        }.bind(this), 3000);
        return
      } else {
        window.scrollTo(0, 0);
        if (action == 'approve') {
          this.approveAlertSuccess = true;
        } else if (action == 'reject') {
          this.rejectAlertSuccess = true;
        } else if (action == 'save') {
          this.saveAlertSuccess = true;
          this.budget.budgetStatus = 'SUBMITTED';
        }
        window.scrollTo(0, 0);
        if (action != 'save') {
          setTimeout(() => {
            this.router.navigate(['/hoshin-listing']);
          }, 3000);
        }
      }
    }, err => {
      this.spinner.hide();
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });

  }

  public printPage() {
    let tempTitle = document.title;
    document.title = "Toyota BPG-" + this.budgetData.siteName + "-" + this.budgetData.chapterName + "-" + this.budgetData.fiscalYear;
    this.printClicked = true;
    setTimeout(() => {
      window.print();
      this.printClicked = false;
      document.title = tempTitle;
    }, 1000);
  }

  saveBtnClick() {
    document.getElementById('approveBtnClick').setAttribute('data-target', '#myModal');
    document.getElementById('approveBtnClick').setAttribute('data-toggle', 'modal');
    this.method = "approveBudget";
    this.param = "save";
    this.msg1 = " Do you want to save the hoshin ?";
  }

}
